import { checkIsPremiumPlan } from 'helper/checkPlan.helper';

const { useSelector } = require('react-redux');

const PremiumPlanWrapper = ({ children }) => {
    const { companyData } = useSelector((params) => params.customization);
    return <>{companyData && checkIsPremiumPlan(companyData?.subscription?.plan) ? children : null}</>;
};
export default PremiumPlanWrapper;
